import HeroSection from "@/components/sections/HeroSection";
import AboutSection from "@/components/sections/AboutSection";
import AIInteractionSection from "@/components/sections/AIInteractionSection";
import CoreModulesSection from "@/components/sections/CoreModulesSection";
import AISection from "@/components/sections/AISection";
import BusinessCardSection from "@/components/sections/BusinessCardSection";
import FutureFeaturesSection from "@/components/sections/FutureFeaturesSection";
import WhyHirerkeySection from "@/components/sections/WhyHirerkeySection";
import UAEAdvantageSection from "@/components/sections/UAEAdvantageSection";
import TechnologySection from "@/components/sections/TechnologySection";
import DemoSection from "@/components/sections/DemoSection";

const Home = () => {
  return (
    <div className="min-h-screen bg-[#1b1b1d]">
      {/* 745px Width Container */}
      <div className="max-w-[745px] mx-auto bg-background shadow-2xl">
        {/* Company Profile Header - Clean White */}
        <div className="relative bg-background py-4 sm:py-6">
          <div className="max-w-[745px] mx-auto px-4 sm:px-6">
            <div className="flex flex-col items-center justify-center gap-2 sm:gap-3">
              <img
                src="https://customer-assets.emergentagent.com/job_hirerprofile/artifacts/etjkyelz_logo-light%20%281%29.png"
                alt="hirerkey"
                className="h-10 sm:h-12 md:h-14 w-auto"
              />
              <h1 className="text-base sm:text-lg md:text-xl font-bold uppercase tracking-widest text-gradient-primary">
                Company Profile
              </h1>
            </div>
          </div>
        </div>

        <main>
          {/* Hero Section - Bright background with subtle elements */}
          <section id="hero" className="relative bg-background">
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
              <div className="absolute top-20 right-10 w-[500px] h-[500px] bg-blue-400/5 rounded-full blur-3xl will-change-transform"></div>
              <div className="absolute bottom-20 left-10 w-[600px] h-[600px] bg-teal-400/5 rounded-full blur-3xl will-change-transform"></div>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-cyan-400/4 rounded-full blur-3xl will-change-transform"></div>
            </div>
            <div className="relative">
              <HeroSection />
            </div>
          </section>

          {/* About Section - Light with subtle dots */}
          <section
            id="about"
            className="relative bg-background dotted-pattern-light"
          >
            <AboutSection />
          </section>

          {/* AI Interaction Section - ChatGPT-like interface */}
          <section id="ai-interaction" className="relative bg-background">
            <AIInteractionSection />
          </section>

          {/* Core Modules - Light purple tint with dots */}
          <section
            id="modules"
            className="relative bg-secondary/30 dotted-pattern-light"
          >
            <CoreModulesSection />
          </section>

          {/* AI Section - Dark background with AI features */}
          <section id="ai" className="relative">
            <AISection />
          </section>

          {/* Business Card - Clean white with bright accents */}
          <section id="business-card" className="relative bg-background">
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
              <div className="absolute top-20 right-10 w-[400px] h-[400px] bg-blue-400/6 rounded-full blur-2xl will-change-transform"></div>
              <div className="absolute bottom-20 left-10 w-[400px] h-[400px] bg-cyan-400/6 rounded-full blur-2xl will-change-transform"></div>
            </div>
            <div className="relative">
              <BusinessCardSection />
            </div>
          </section>

          {/* Future Features - Light purple with dots */}
          <section
            id="future"
            className="relative bg-muted dotted-pattern-light"
          >
            <FutureFeaturesSection />
          </section>

          {/* Why hirerkey - Light muted background with bright accents */}
          <section
            id="why"
            className="relative bg-muted/50 dotted-pattern-light overflow-hidden"
          >
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-400/8 rounded-full blur-2xl will-change-transform"></div>
              <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-cyan-400/8 rounded-full blur-2xl will-change-transform"></div>
            </div>
            <div className="relative">
              <WhyHirerkeySection />
            </div>
          </section>

          {/* UAE Advantage - Clean white */}
          <section id="uae" className="relative bg-background">
            <UAEAdvantageSection />
          </section>

          {/* Technology - Light purple background with bright accents */}
          <section
            id="technology"
            className="relative bg-secondary/15 dotted-pattern-light"
          >
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute top-1/4 right-10 w-[400px] h-[400px] bg-blue-400/6 rounded-full blur-2xl will-change-transform"></div>
              <div className="absolute bottom-1/4 left-10 w-[400px] h-[400px] bg-teal-400/6 rounded-full blur-2xl will-change-transform"></div>
            </div>
            <div className="relative">
              <TechnologySection />
            </div>
          </section>

          {/* Demo Section - Clean white with subtle pattern */}
          <section
            id="demo"
            className="relative bg-background dotted-pattern-light"
          >
            <DemoSection />
          </section>

          {/* Footer */}
          <footer
            className="relative bg-background border-t border-border"
            style={{ maxHeight: "12px" }}
          >
            <div className="max-w-[745px] mx-auto px-4 sm:px-6 flex items-center justify-between h-12">
              <p className="text-[10px] text-gray-400">
                Document version: hy-20251017-01
              </p>
              <p className="text-[10px] text-gray-400">
                KSM Emirates Group LLC FZ. All Rights Reserved.
              </p>
            </div>
          </footer>
        </main>
      </div>
    </div>
  );
};

export default Home;
